import { FC } from 'react'

import { formatCurrencyCent, reportPercents } from 'commons/utils'
import { Layer, PageSectionSecondary } from 'ui/components'

import { HRRBankAccount } from '../../../../types'

import * as SC from './styles'

export const OtherBankingActivity: FC<{ bankAccount: HRRBankAccount }> = ({ bankAccount }) => {
  const {
    deposits: { showOtherActivity }
  } = bankAccount

  if (!showOtherActivity) {
    return null
  }

  const { currentPeriod, priorPeriod, difference, changesPriorPeriod } = showOtherActivity

  return (
    <PageSectionSecondary face="outlined" title="Other Banking Activity">
      <Layer rounded shadowed>
        <SC.Columns>
          <SC.Table>
            <thead>
              <tr>
                <SC.Td rowSpan={2}></SC.Td>
                <SC.Th rowSpan={2}>Total</SC.Th>
                <SC.Th rowSpan={2}>Cash Withdrawals</SC.Th>
                <SC.Th rowSpan={2}>Check Debits</SC.Th>
                <SC.Th rowSpan={2}>ACH Debits</SC.Th>
                <SC.Th colSpan={2} $bottomBorder>
                  Debit Cards
                </SC.Th>
                <SC.Th colSpan={2} $bottomBorder>
                  Transfer
                </SC.Th>
                <SC.Th colSpan={2} $bottomBorder>
                  Wires
                </SC.Th>
                <SC.Th colSpan={2} $bottomBorder>
                  Sweeps
                </SC.Th>
                <SC.Th rowSpan={2}>Bank Fees</SC.Th>
                <SC.Th rowSpan={2}>Money Orders Purchased</SC.Th>
                <SC.Th rowSpan={2}>Cashiers Checks Purchased</SC.Th>
                <SC.Th colSpan={2} $bottomBorder>
                  CB&T Credit Card
                </SC.Th>
              </tr>
              <tr>
                <SC.Th>Credits</SC.Th>
                <SC.Th>Debits</SC.Th>
                <SC.Th>Credits</SC.Th>
                <SC.Th>Debits</SC.Th>
                <SC.Th>Credits</SC.Th>
                <SC.Th>Debits</SC.Th>
                <SC.Th>Incoming</SC.Th>
                <SC.Th>Outgoing</SC.Th>
                <SC.Th>Charges</SC.Th>
                <SC.Th>Payments</SC.Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <SC.Td>Current Period</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.total)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.cashWithdrawals)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.checksDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.ACHDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.debitCardsCredits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.debitCardsDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.transferCredits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.transferDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.wiresIncoming)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.wiresOutgoing)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.sweepsIncoming)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.sweepsOutgoing)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.bankFees)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.moneyOrdersPurchased)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.cashiersChecksPurchased)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.cbtCreditCardCharges)}</SC.Td>
                <SC.Td>{formatCurrencyCent(currentPeriod.cbtCreditCardPayments)}</SC.Td>
              </tr>
              <tr>
                <SC.Td>Prior Period</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.total)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.cashWithdrawals)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.checksDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.achDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.debitCardsCredits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.debitCardsDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.transferCredits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.transferDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.wiresIncoming)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.wiresOutgoing)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.sweepsIncoming)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.sweepsOutgoing)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.bankFees)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.moneyOrdersPurchased)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.cashiersChecksPurchased)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.cbtCreditCardCharges)}</SC.Td>
                <SC.Td>{formatCurrencyCent(priorPeriod.cbtCreditCardPayments)}</SC.Td>
              </tr>
              <tr>
                <SC.Td>Difference</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.total)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.cashWithdrawals)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.checksDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.achDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.debitCardsCredits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.debitCardsDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.transferCredits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.transferDebits)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.wiresIncoming)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.wiresOutgoing)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.sweepsIncoming)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.sweepsOutgoing)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.bankFees)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.moneyOrdersPurchased)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.cashiersChecksPurchased)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.cbtCreditCardCharges)}</SC.Td>
                <SC.Td>{formatCurrencyCent(difference.cbtCreditCardPayments)}</SC.Td>
              </tr>
              <tr>
                <SC.Td>
                  <b>% Change</b>
                </SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.total.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.cashWithdrawals.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.checksDebits.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.achDebits.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.debitCardsCredits.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.debitCardsDebits.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.transferCredits.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.transferDebits.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.wiresIncoming.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.wiresOutgoing.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.sweepsIncoming.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.sweepsOutgoing.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.bankFees.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.moneyOrdersPurchased.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.cashiersChecksPurchased.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.cbtCreditCardCharges.percent)}</SC.Td>
                <SC.Td>{reportPercents(changesPriorPeriod.cbtCreditCardPayments.percent)}</SC.Td>
              </tr>
            </tbody>
          </SC.Table>
        </SC.Columns>
      </Layer>
    </PageSectionSecondary>
  )
}
